// extracted by mini-css-extract-plugin
module.exports = {"headerContent":"HeaderContent_headerContent__1qoF2","content":"HeaderContent_content__2ivQz","imgCont":"HeaderContent_imgCont__2z66q","title":"HeaderContent_title__c78xS"};